import React, { useState } from "react";
import api from '../api/axiosInstance';
import { Container, Form, Button, Card, Alert } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import AppNavbar from "../components/AppNavbar";

const LoginPage = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [message, setMessage] = useState(null);

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

const handleSubmit = async (e) => {
  e.preventDefault();
  try {
    const res = await api.post("/auth/login", form);

    // TOKEN KAYDET
    localStorage.setItem("token", res.data.token);

    // ⬅️ EKSİK OLAN KISIM (çok önemli!)
    localStorage.setItem("user", JSON.stringify(res.data.user));

    setMessage({ type: "success", text: "Giriş başarılı! Yönlendiriliyorsunuz..." });

    // Yönlendirme
    if (!res.data.user.isApproved) {
      setTimeout(() => navigate("/odeme"), 1200);
    } else {
      setTimeout(() => navigate("/panel"), 1200);
    }
  } catch (err) {
    setMessage({
      type: "danger",
      text: err.response?.data?.message || "Giriş hatası.",
    });
  }
};

  return (
    <>
      <AppNavbar />
      <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: "100vh" }}>
        <Card className="p-4 shadow-lg" style={{ width: "100%", maxWidth: "420px", borderRadius: "15px" }}>
          <h3 className="text-center mb-4" style={{ color: "#2D8A7A" }}>
            Giriş Yap
          </h3>
          {message && <Alert variant={message.type}>{message.text}</Alert>}
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>E-posta</Form.Label>
              <Form.Control type="email" name="email" value={form.email} onChange={handleChange} required />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>Şifre</Form.Label>
              <Form.Control type="password" name="password" value={form.password} onChange={handleChange} required />
            </Form.Group>

            <Button type="submit" className="w-100 btn-primary">
              Giriş Yap
            </Button>

            <div className="text-center mt-3">
              <a href="/register" style={{ color: "#2D8A7A" }}>
                Hesabın yok mu? Kayıt ol
              </a>
            </div>
          </Form>
        </Card>
      </Container>
    </>
  );
};

export default LoginPage;
